import React, { useState } from "react";
import Query from "components/Query";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";



const PageCardB = React.memo(({ url, noImg }) => {
  const [buttonId, setButtonId] = useState();

  const handleMouseEnter = (id) => {
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setButtonId("");
  };

  const history = useHistory();

  return (
    <div className="foreign-guests-main">
      <Query url={url}>
        {({ data }) => {
          return (
            // <div className="foreign-guests-wrapper box-shadow">
            //   {!noImg && <div
            //     className="foreign-guests-image"
            //     style={{
            //       background: `url(${process.env.REACT_APP_BASE_URL}/${data.mainImage.url}) no-repeat center center`,
            //     }}
            //   />}
            //   <div className="foreign-guests-contents">
            //     <h4 className="primary-color">
            //       <img
            //         src={`${process.env.REACT_APP_BASE_URL}/resources/img/sabinehospital-icons/sabinehospital-heartbeat.svg`}
            //         style={{ width: '32px' }}
            //         alt=""
            //       />{' '}
            //       {data.title}
            //     </h4>
            //     <div className="ql-editor" dangerouslySetInnerHTML={{ __html: `${data.content.slice(0, 200)}...` }} />

            //     <div className="btn-wrapper">
            //         <Link to={`/pages/foreign-guests`} className="btn small-btn">

            //         Read More <i className="fas fa-arrow-right" />
            //       </Link>
            //     </div>
            //   </div>
            // </div>
            <>
              <div className="foreign-guest-wrapper">
                <div className="foreign-title-div wow fadeInUp">
                  <h3 className="a-medical-tourism">
                    A Medical Tourism Journey
                  </h3>
                  <h2 className="crossing-borders-for">
                    Crossing Borders for Care
                  </h2>
                </div>
                <div className="foreign-guest-card  wow slideInRight">
                  <img
                    className="foreign-image-banner"
                    src="/img/for-guests.jpg"
                  />
                  <div className="foreign-guests-inner">
                    <h3>Foreign Guests</h3>
                    <p>
                      We’re the pioneers in world-class infertility care, and in
                      being so we’ve won the hearts of numerous foreign guests.
                      Understanding unlike needs of our overseas clients is one
                      of our primary goals and we have a dedicated program
                      tailored for their hospitality and treatment facilitation.
                    </p>
                    <button
                    onClick = {()=>history.push('/pages/foreign-guests')}
                    onMouseEnter={() => {
                      handleMouseEnter("ForeignGuests");
                    }}
                    onMouseLeave={handleMouseLeave}>
                      Know More
                      <img src={
                      buttonId == "ForeignGuests"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
                    </button>
                  </div>
                </div>
              </div>
              <div className="foreign-guest-wrapper">
                <div className="foreign-guest-card wow slideInLeft">
                  <img
                    className="foreign-image-banner"
                    src="/img/hosp-hub.jpg"
                  />
                  <div className="foreign-guests-inner">
                    <h3>Medical Tourism</h3>
                    <p>
                      Medical Tourism is the synergy between hospitals and the
                      Tourism industry. The state is all set for a leap in
                      medical tourism. More and more hospitals are joining hands
                      with the tourism industry to benefit their services. The
                      high priority for health in Kerala is bound to make this
                      relatively new aspect of tourism into a multi-crore
                      industry in the future.
                    </p>
                    <button
                    onClick = {()=>history.push('/pages/medical-tourism')}
                    onMouseEnter={() => {
                      handleMouseEnter("medicalTourism");
                    }}
                    onMouseLeave={handleMouseLeave}
                    id="medicalTourism">
                      Know More
                      <img src={
                      buttonId == "medicalTourism"
                        ? "/img/arrow-right-big.svg"
                        : "/img/arrow-right.svg"
                    } />
                    </button>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </Query>
    </div>
  );
});

PageCardB.propTypes = {
  url: PropTypes.string.isRequired,
  noImg: PropTypes.bool,
};

PageCardB.defaultProps = {
  noImg: false,
};

export default PageCardB;
